export const SET_LOCAL_PLAYER = 'PLAYER/PLAY';
export const ROUND_END = 'PLAYER/ROUND_END';
